/**
 * Determines the background CSS class for displaying discrepancy between realized and planned values.
 *
 * @param realizedValue - The actual realized value
 * @param plannedValue - The planned/expected value
 * @param canSeeRealized - Whether the user has permission to see realized values
 * @returns CSS class name for background color ('bg-realized', 'bg-orange', 'bg-yellow', or empty string)
 */
export const getRealizedBackground = (
    realizedValue: number,
    plannedValue: number,
    canSeeRealized: boolean = true
): string => {
    if (!canSeeRealized || plannedValue === 0 || plannedValue == null || realizedValue == null || realizedValue === 0) {
        return '';
    } else if (realizedValue === plannedValue) {
        return 'bg-realized';
    } else if (realizedValue > plannedValue) {
        return 'bg-orange';
    } else {
        return 'bg-yellow';
    }
};

/**
 * Determines if realized values can be displayed based on entity type and status.
 *
 * @param entityType - The type of entity ('ServiceRequest' or 'DeliveryOrder')
 * @param statusId - The entity status ID
 * @param shipmentType - The shipment type (required for ServiceRequest, optional for DeliveryOrder)
 * @returns true if realized values should be visible
 */
export const canSeeRealized = (
    entityType: 'ServiceRequest' | 'DeliveryOrder',
    statusId: string,
    shipmentType?: string
): boolean => {
    switch (entityType) {
        case 'DeliveryOrder':
            return ['APP', 'COM', 'PFA'].includes(statusId);
        case 'ServiceRequest':
            return ['INP', 'COM'].includes(statusId) && shipmentType === 'NONCNTC';
        default:
            return false;
    }
};
